import { gql } from '@apollo/client'

export const PROFILE_OVERVIEW = gql`
  query ProfileOverview(
    $startDate: ISO8601Date!
    $endDate: ISO8601Date!
    $previousStartDate: ISO8601Date!
    $previousEndDate: ISO8601Date!
  ) {
    coachingInquiries {
      id
      createdAt
    }
    currentUser {
      coachProfileAnalytics(startDate: $startDate, endDate: $endDate) {
        impressions
        views
      }
      previousCoachProfileAnalytics: coachProfileAnalytics(
        startDate: $previousStartDate
        endDate: $previousEndDate
      ) {
        impressions
        views
      }
      attributes {
        ... on Coach {
          hasPaidTierSubscription
          facilities {
            id
            name
            coachProfilesFacilities {
              visible
            }
          }
          coachProfile {
            coachProfileId
            firstName
            lastName
            profilePhoto
            title
            status
            city
            state
            customSlug
            facilities {
              facilityName
              city
              state
            }
            coach {
              canPromoteContent
            }
          }
        }
      }
    }
  }
`
